import * as $ from 'jquery';
var Common = /** @class */ (function () {
    function Common() {
        var _this = this;
        this.header = document.getElementById("header");
        this.headerWrapper = document.getElementById("headerWrapper");
        if (this.header) {
            // Get the offset position of the navbar
            this.sticky = this.header.offsetTop;
        }
        window.onscroll = function () {
            _this.onScroll();
        };
    }
    Common.prototype.onScroll = function () {
        if (this.header && this.headerWrapper) {
            this.checkStickyHeader(this.header, this.headerWrapper);
        }
    };
    Common.prototype.setInitialDoc = function (type) {
        var userLang = navigator.language;
        if (userLang.toLowerCase() == "pt-br") {
            userLang = "br";
        }
        this.lang = userLang.split('-')[0].toLowerCase();
        if (this.lang != 'es' &&
            this.lang != 'en' &&
            this.lang != 'it' &&
            this.lang != 'pt' &&
            this.lang != 'br' &&
            this.lang != 'de') {
            this.lang = 'en';
        }
        this.setDoc(type);
    };
    Common.prototype.add = function (number1, number2) {
        return number1 + number2;
    };
    Common.prototype.langClick = function (type) {
        var self = this;
        $(".lang").click(function () {
            self.lang = $(this).attr("langv");
            self.setDoc(type);
        });
    };
    Common.prototype.setDoc = function (type) {
        var _this = this;
        var HtmlSanitizer = require('../../node_modules/@jitbit/htmlsanitizer/HtmlSanitizer.js').HtmlSanitizer;
        var sanitizedHtml = "";
        $(".lang").removeClass("active");
        $(".lang-" + this.lang).addClass("active");
        if (type == "tcpp") {
            this.tchtm = "";
            this.pphtm = "";
            $.when($.get("resources/htm/tc/" + this.lang + ".htm", function (data) { return _this.onGetMultiple(HtmlSanitizer.SanitizeHtml(data), "tc"); }), $.get("resources/htm/pp/" + this.lang + ".htm", function (data) { return _this.onGetMultiple(HtmlSanitizer.SanitizeHtml(data), "pp"); })).then(function () {
                $(".doc").html(_this.tchtm + _this.pphtm);
            });
        }
        if (type == "tc") {
            $.get("resources/htm/tc/" + this.lang + ".htm", function (data) { return _this.onGet(HtmlSanitizer.SanitizeHtml(data)); });
        }
        if (type == "pp") {
            $.get("resources/htm/pp/" + this.lang + ".htm", function (data) { return _this.onGet(HtmlSanitizer.SanitizeHtml(data)); });
        }
        $(".pdf-version a").attr("href", "resources/pdf/" + type + "_" + this.lang + ".pdf");
    };
    Common.prototype.onGet = function (data) {
        $(".doc").html(data);
    };
    Common.prototype.onGetMultiple = function (data, type) {
        if (type === "pp") {
            this.pphtm = data;
        }
        if (type === "tc") {
            this.tchtm = data;
        }
    };
    Common.prototype.checkStickyHeader = function (header, headerWrapper) {
        if (window.scrollY > this.sticky) {
            header.classList.add("sticky");
            var height = header.offsetHeight;
            headerWrapper.style.height = height + "px";
        }
        else {
            header.classList.remove("sticky");
            headerWrapper.style.height = "auto";
        }
    };
    return Common;
}());
export { Common };
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
